'use strict';

function UrlHelpers() { }

UrlHelpers.OpenBrowserTab = function (url, openInNewTab, navigationId) {
    // If openInNewTab is not set, read value from user settings
    if (openInNewTab === undefined && $.agito.openInNewTab) {
        openInNewTab = $.agito.openInNewTab;
    }

    if (!navigationId) {
        navigationId = window.agApp ? window.agApp.navigation.currentNavigationId : undefined;
    }

    if (navigationId) {
        url = UrlHelpers.AddQueryParam(url, 'navigationId', navigationId);
    }
    
    if (!openInNewTab || url.toUpperCase().indexOf('#DIALOG=') != -1) {
        const newUrl = new URL(url, document.baseURI);

        if (newUrl.origin === window.location.origin && newUrl.pathname === window.location.pathname && newUrl.search === window.location.search && newUrl.hash !== window.location.hash) {
            // special handle dialogs, so we can return reference to opened dialog
            const hashChangeEvent = new HashChangeEvent("hashchange", { newURL: newUrl.toString(), oldURL: window.location.href });
            window.dispatchEvent(hashChangeEvent);

            return hashChangeEvent.legacyDialogNodePromise;
        }
        else {
            UrlHelpers.PushHistory(window.location.href);
            window.location = url;
        }
    } else {
        let wind = window.open(url, '_blank'); 

        if(wind != null)
            wind.focus();
    }

};

UrlHelpers.GetHistory = function () {
    var historyStorage = JSON.parse(window.sessionStorage.getItem("history"));
    if (!historyStorage)
        historyStorage = [];

    return historyStorage;
};

UrlHelpers.PushHistory = function (url) {
    var historyStorage = UrlHelpers.GetHistory();

    historyStorage.push({
        url: url
    });
    window.sessionStorage.setItem('history', JSON.stringify(historyStorage));
};

UrlHelpers.PopHistory = function() {

    if (!UrlHelpers.CountHistory()) {
        return { url: $.agito.baseUrl };
    }

    var historyStorage = UrlHelpers.GetHistory();

    var history = historyStorage.pop();
    window.sessionStorage.setItem('history', JSON.stringify(historyStorage));

    return history;
};

UrlHelpers.CountHistory = function () {
    var historyStorage = UrlHelpers.GetHistory();

    return historyStorage.length;
};

UrlHelpers.OpenBrowserTabWithName = function (url, name) {
    window.open(url, name);
};

UrlHelpers.ParseQueryString = function (url) {

    var urlParams = {};

    url.replace(
        new RegExp("([^?=&]+)(=([^&]*))?", "g"),
        function ($0, $1, $2, $3) {
            urlParams[$1] = $3;
        }
    );

    return urlParams;
};

// Get path of URL (without query).
UrlHelpers.GetPath = function (url) {
    var splitIndex = url.indexOf('?');
    if (splitIndex === -1)
        return url;

    return url.slice(0, splitIndex);
};

// Get query object.
UrlHelpers.GetQuery = function (url) {
    var queryParams = {};

    var hash;
    var hashes = url.replace(UrlHelpers.GetPath(url), '').replace('?', '').split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        queryParams[hash[0]] = decodeURIComponent((hash[1] + '').replace(/\+/g, '%20'));
    }

    return queryParams;
};

// Add query parameter to URL and return new URL string.
UrlHelpers.AddQueryParam = function (url, key, value) {

    try {
        var url2 = new URL(url);
        url2.searchParams.set(key, value);
        return url2.href;
    } catch (error) {
        var url2 = new URL('https://xxxxxxxxxx' + url);
        url2.searchParams.set(key, value);

        return url2.href.replace('https://xxxxxxxxxx', '');
    }
};

UrlHelpers.GetQueryParam = function (url, key) {
    return AjaxHelpers.GetUrlParam(key, url);
};

UrlHelpers.RemoveUrlParameter = function (url, parameter) {

    var urlparts = url.split('?');

    if (urlparts.length >= 2) {

        var prefix = encodeURIComponent(parameter) + '=';
        var pars = urlparts[1].split(/[&;]/g);

        //reverse iteration as may be destructive
        for (var i = pars.length; i-- > 0;) {
            //idiom for string.startsWith
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
        return url;
    } else {
        return url;
    }
};
